import { ChromeExtensionService } from 'src/app/services/chrome/chrome-extension.service';

import { catchError, filter, map, mergeAll, shareReplay, switchMap } from 'rxjs/operators';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { DOCUMENT, ViewportScroller } from '@angular/common';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { BreakPointService } from 'src/app/services/utilites/break-point.service';
import { SettingsService } from 'src/app/services/firestore/settings.service';
import { MainSettings, ThemeType } from 'src/app/model/settings.model';
import { AuthService } from 'src/app/services/authentication/auth.service';
import { StripeService } from 'src/app/services/stripe/stripe.service';
import { SubscriptionStatus } from 'src/app/model/stripe.models';
import { SSL_OP_ALLOW_UNSAFE_LEGACY_RENEGOTIATION } from 'constants';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {

  ThemeType = ThemeType;
  theme = ThemeType.SYSTEM;

  sidenavExpanded: boolean = true;
  sidenavMouseOver: boolean = false;
  themeIsDark = false;
  //selected: string = "home";
  //reviewsTabActive = false;

  queryDoneReviews = {done: 1};

  private lastPoppedUrl: string | undefined;
  private yScrollStack: number[] = [];
  private baseScrollOptions: ScrollToOptions = {
    left: 0,
    top: 0,
    behavior: 'smooth',
  };

  ngOnInit(): void {

    console.log("SHELL on init");


    // Keep the public (logged-out) experience in light mode. Once a user's
    // settings are loaded, the subscription below applies their saved theme.
    this.applyTheme(false);

    //intialized the theme with the system theme
    //this.applyTheme(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);

    this.settingsService.settingsChange.subscribe((settings: MainSettings) => {

      this.theme = settings.theme;

      if (settings.theme === ThemeType.SYSTEM) {
        this.themeIsDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
      } else {
        this.themeIsDark = settings.theme === ThemeType.DARK;
      }

      this.applyTheme(this.themeIsDark);
    })

  }

  constructor(private viewport: ViewportScroller,
    private router: Router, public breakPointService: BreakPointService,
    private renderer: Renderer2, @Inject(DOCUMENT) private document: Document, public settingsService: SettingsService,
    private authService: AuthService, private stripeService: StripeService,
    public chromeExtensionService: ChromeExtensionService) {}

  getThemeIcon() {
    switch (this.theme) {
      case ThemeType.LIGHT:
        return 'wb_sunny';
      case ThemeType.DARK:
        return 'nights_stay';
      case ThemeType.SYSTEM:
        return 'brightness_6';
    }

    return 'brightness_6';
  }

  isLogged() {
    return !!this.authService.userId;
  }

  isLoggedAndActive() {
    return (!!this.authService.userId) && ((this.stripeService.currentSubscriptionStatus === SubscriptionStatus.ACTIVE)
      || (this.stripeService.currentSubscriptionStatus === SubscriptionStatus.TRIALING));
  }

  handleMenuClick(drawer) {
    if (this.breakPointService.isHandset) {
      drawer.toggle();
      console.log("is handset");
    } else if (this.breakPointService.isTablet) {
      this.sidenavMouseOver = !this.sidenavMouseOver;
    }
  }

  sidenavToggle(drawer) {

    if (this.breakPointService.isHandset) {
      drawer.toggle();
      console.log("is handset");
    } else if (this.breakPointService.isWeb) {
      this.breakPointService.sidenavExpanded = !this.breakPointService.sidenavExpanded;
    } else if (this.breakPointService.isTablet) {
      this.sidenavMouseOver = !this.sidenavMouseOver;
    }
/*
    this.isHandset$.subscribe(isHandset => {
      if (!isHandset) {
        this.sidenavExpanded = !this.sidenavExpanded;
        console.log("is not hanset");
      } else {
        drawer.toggle();
        console.log("is handset");
      }
    }).unsubscribe();*/

  }

ngAfterContentInit(): void {
  //fiz pra ir pro começo topo quando clica em uma nova tela.
  this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {

    console.log("router changed");

    //Do something with the NavigationEnd event object
    const sidenavContentElement = document.querySelector(
      '.mat-sidenav-content',
    );

    if (!sidenavContentElement) {
      return;
    }

    sidenavContentElement.scroll({ top: 0, left: 0/*, behavior: 'smooth' */});

  });

/*
  this.router.events.subscribe((ev: any) => {
    const sidenavContentElement = document.querySelector(
      '.mat-sidenav-content',
    );

    console.log("router3 changed");

    if (!sidenavContentElement) {
      return;
    }
    if (ev instanceof NavigationStart) {

    } else if (ev instanceof NavigationEnd) {
      //sidenavContentElement.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
  });*/
}

  applyTheme(isDark: boolean) {
    if (isDark) {
      console.log("Dark Theme selected.");
      this.renderer.addClass(this.document.body, 'my-dark-theme');
      this.renderer.removeClass(this.document.body, 'my-light-theme');
      //this.setThemeLink('assets/themes/md-dark-indigo1.css');
      this.setThemeLink('assets/themes/md-dark-indigo/theme.css');
    } else {
      this.renderer.addClass(this.document.body, 'my-light-theme');
      this.renderer.removeClass(this.document.body, 'my-dark-theme');
      //this.setThemeLink('assets/themes/md-light-indigo1.css');
      this.setThemeLink('assets/themes/md-light-indigo/theme.css');
    }
  }

  setThemeLink(href: string) {
    const themeLink = this.document.getElementById('theme-link') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = href;
    } else {
      const link = this.document.createElement('link');
      link.id = 'theme-link';
      link.rel = 'stylesheet';
      link.href = href;
      document.head.appendChild(link);
    }
  }

  logout() {
    this.authService.logout();
    this.authService.userId = null;

    if (environment.environmentName === 'web') {
      // Recarrega a aplicação
      window.location.reload();
    } else if (environment.environmentName === 'extension') {
      this.router.navigate(['/login']);
    }
  }

  toggleTheme(themeType: ThemeType) {
    this.settingsService.updateMainSettings({theme: themeType});
  }

  isChromeExtension () {
    return this.settingsService.isChromeExtension();
  }

  getSelectedMenuColor() {
    return (this.themeIsDark) ? '#656565' : '#c7c7c7';
  }

}
